import { Fade } from "@mui/material";

import { useState } from "react";

type Props = {
  render: () => JSX.Element;
  delay: number;
};

export default function RenderAnimation({ delay = 300, render }: Props) {
  const [renderChildren, setRenderChildrem] = useState<boolean>(false);

  return (
    <Fade
      in={true}
      timeout={1000}
      style={{ transitionDelay: `${delay}ms` }}
      addEndListener={() => setRenderChildrem(true)}
    >
      <div style={{ height: "100%" }}>{renderChildren ? render() : <></>}</div>
    </Fade>
  );
}
